export default "__VITE_ASSET__00064a94__"